import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useWishlist } from "@/lib/wishlist";
import { Heart, Trash2 } from "lucide-react";

export default function Wishlist() {
  const { user } = useAuth();
  const { toggle, ids } = useWishlist();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get("/me/wishlist").then(({ data }) => setItems(data.items || [])).catch(() => setItems([])).finally(() => setLoading(false)); };
  useEffect(() => { if (user) load(); else setLoading(false); }, [user, ids.length]);

  if (!user) {
    return (
      <main className="sq-container py-20 text-center" data-testid="wishlist-page">
        <Heart size={32} className="mx-auto text-squire-jeans" />
        <h1 className="font-display text-3xl mt-4">Your Wishlist</h1>
        <p className="text-[#4B5563] mt-2">Sign in to save your favourite pieces.</p>
        <Link to="/auth" className="sq-btn-primary inline-flex mt-5">Sign in</Link>
      </main>
    );
  }

  const href = (it) => it._kind === "fabric" ? `/fabric/${it.id}` : `/product/${it.id}`;

  return (
    <main className="sq-container py-12" data-testid="wishlist-page">
      <div className="sq-eyebrow text-squire-jeans">Saved</div>
      <h1 className="font-display text-4xl md:text-5xl mt-2">My Wishlist</h1>

      {loading ? <div className="text-sm text-[#4B5563] mt-8">Loading…</div> : items.length === 0 ? (
        <div className="border border-black/10 rounded-lg p-12 text-center mt-8">
          <Heart size={28} className="mx-auto text-[#D1D5DB]" />
          <p className="text-[#4B5563] mt-3">Nothing saved yet.</p>
          <Link to="/fabrics" className="sq-btn-primary inline-flex mt-4">Browse Fabrics</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 mt-8">
          {items.map((it) => (
            <div key={it.id} className="group border border-black/10 rounded-lg overflow-hidden hover:shadow-md transition-shadow" data-testid={`wishlist-item-${it.id}`}>
              <Link to={href(it)} className="block aspect-[3/4] bg-[#F5F5F5] overflow-hidden">
                <img src={(it.images || [])[0]} alt={it.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </Link>
              <div className="p-3">
                <Link to={href(it)} className="font-medium text-sm line-clamp-1 hover:text-squire-jeans">{it.name}</Link>
                <div className="flex items-center justify-between mt-1">
                  <span className="text-sm">{formatINR(it.price || it.price_per_meter)}</span>
                  <button onClick={() => toggle(it.id)} data-testid={`wishlist-remove-${it.id}`} className="text-[#9CA3AF] hover:text-red-600" aria-label="Remove"><Trash2 size={16} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}
